import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo, useState } from "react";
import { createSingletonComponent, useSafeContext, } from "@aviv-unified-frontend/internal";
import { GLOBAL_KEY } from "./constants";
const INTERNAL_GLOBAL_KEY = Symbol(GLOBAL_KEY);
const GlobalStoreContext = createContext(null);
export const createGlobalStoreContext = ({ initialApplication, headerFooterConfig, applicationId, }) => {
    return {
        [INTERNAL_GLOBAL_KEY]: {
            initialApplication,
            headerFooterConfig,
            applicationId,
        },
    };
};
export const GlobalStoreProvider = createSingletonComponent("GlobalStoreProvider", ({ children, context }) => {
    const { headerFooterConfig, initialApplication, applicationId: initialApplicationId, } = context[INTERNAL_GLOBAL_KEY];
    const [applicationId, setApplicationId] = useState(initialApplicationId);
    const value = useMemo(() => {
        return {
            applicationId,
            headerFooterConfig,
            initialApplication,
            setApplicationId,
        };
    }, [
        headerFooterConfig,
        initialApplication,
        applicationId,
        setApplicationId,
    ]);
    return (_jsx(GlobalStoreContext.Provider, { value: value, children: children }));
});
export const useGlobalStore = () => useSafeContext({
    package: "@aviv-unified-frontend/branded-shell",
    module: "global",
}, GlobalStoreContext);
